import { LicenseType } from '~/types/licenses/licenses';

/**
 * Which version of the deletion-guide alert a member is shown, if any.
 *
 * 'unlicensed' and 'upgrade' are offers, and stand whether or not anything has been tracked from
 * this company. 'automated' is a claim that we are already handling this company for the member,
 * so it is withheld until there is an exposure being handled: the drawer opened over a company on
 * its own says two rows above that no exposure has been tracked from it, and offers the button
 * that would start one.
 */
export type DeletionGuideAlertVariant = 'unlicensed' | 'upgrade' | 'automated';

export interface DeletionGuideAlertContext {
    /** Name of the member's active license, if they hold one. */
    licenseName?: string | null;
    /** Whether the drawer is showing a tracked exposure rather than a company on its own. */
    hasExposure: boolean;
}

export const getDeletionGuideAlertVariant = ({
    licenseName,
    hasExposure,
}: DeletionGuideAlertContext): DeletionGuideAlertVariant | null => {
    if (!licenseName) {
        return 'unlicensed';
    }

    if (licenseName === LicenseType.ESSENTIALS) {
        return 'upgrade';
    }

    return hasExposure ? 'automated' : null;
};
